/*
 * @Author: finian
 * @Date: 2021-01-26 16:03:27
 * @LastEditors: your name
 * @LastEditTime: 2021-01-27 10:02:03
 */
/*jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 200, plusplus: true, sloppy: true, newcap: true, sub: true, regexp: true, continue: true, forin: true*/
/*global mdev: true, console: true, require: true, module: true*/
import config from 'config';
import sfax from '../api/sfax';
const {houseDomain} = config
export default {
  jiaMengSubmit: payload => sfax({
    url: `${houseDomain}/baseApi/joinBiz`,
    data: payload,
    withCredentials: true,
    type: 'post',
    contentType: 'application/x-www-form-urlencoded'
  })
}


// WEBPACK FOOTER //
// ./src/model/service/jia-meng.js